import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.1.5_@babel+core@7.28.6_@opentelemetry+api@1.9.0_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/next/dist/client/app-dir/link.js");
